import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { BForm } from '@prague-digi/ui-components'

import messages from '../../i18n'
import {
  errorHandler,
  form,
  FormInterface,
  intl,
  IntlInterface,
  wizard,
  WizardInterface,
} from '../../hoc'
import { ReduxState } from '../../types'
import { clientActions, modalDialogActions } from '../../redux'
import {
  BCheckbox,
  BMoneyInput,
  PageControlButtons,
  PrefillFormButton,
  Title,
} from '../../components'
import validate from './FinanceIncome.validate'
import { API_ERROR } from '../../constants/modals'
import { ApiErrorInfo, Response } from '../../api/api'

interface Props extends WizardInterface, FormInterface, IntlInterface {
  isModal?: boolean
  onClose: any
  onContinue: any
  saveFinanceIncome: any
  showModalDialog: any
  storeData: any
}

const FORM_NAME = 'FinanceIncome'

export class FinanceIncome extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    props.initialize({ ...props.storeData })
  }

  onSubmit = () => {
    this.props.handleSubmit(this.saveFinanceIncomeCallback)()
  }

  onBack = () => {
    if (this.props.onClose) {
      this.props.onClose()
    } else {
      this.props.wizard.gotoPrevious()
    }
  }

  saveFinanceIncomeCallback = () => {
    this.props.saveFinanceIncome({
      success: () => {
        if (this.props.onContinue) {
          this.props.onContinue()
        } else {
          this.props.wizard.gotoNext()
        }
      },
      error: (errorInfo: ApiErrorInfo) => {
        if (errorInfo.type === Response.dataError && errorInfo.errors) {
          this.props.setErrors(FORM_NAME, errorInfo.errors)
        } else {
          this.props.showModalDialog(API_ERROR({ errorInfo, onRetry: this.onSubmit }))
        }
      },
    })
  }

  render() {
    const { isModal, invalid, translate, translateHTML } = this.props

    return (
      <BForm id={FORM_NAME}>
        <Title center={isModal} message={messages.FinanceIncome.title} subTitle={!isModal} />

        <BMoneyInput
          messages={{
            label: translate(messages.FinanceIncome.netIncomeLabel),
            notice: translateHTML(messages.FinanceIncome.netIncomeNote),
          }}
          name="net3MonthIncome"
        />
        <BMoneyInput
          messages={{
            label: translate(messages.FinanceIncome.familyIncomeLabel),
            notice: translateHTML(messages.FinanceIncome.familyIncomeNote),
          }}
          name="net3MonthHouseholdIncome"
        />
        <BCheckbox
          name="taxCrOnlyFlag"
          messages={{ label: translate(messages.FinanceIncome.taxesInCzechia) }}
          testid="taxCrOnlyFlag"
        />
        <PageControlButtons
          disableSubmit={invalid}
          isModal={isModal}
          onSubmit={this.onSubmit}
          secondaryAction={this.onBack}
        />

        <PrefillFormButton formName="FinanceIncome" />
      </BForm>
    )
  }
}

export default compose(
  errorHandler('containers/FinanceIncome/FinanceIncome.tsx'),
  wizard,
  connect(
    (state: ReduxState) => ({
      storeData: {
        net3MonthIncome: state.client.net3MonthIncome,
        net3MonthHouseholdIncome: state.client.net3MonthHouseholdIncome,
        taxCrOnlyFlag: state.client.taxCrOnlyFlag,
      },
    }),
    {
      saveFinanceIncome: clientActions.saveFinanceIncome,
      showModalDialog: modalDialogActions.showModalDialog,
    }
  ),
  form({
    name: FORM_NAME,
    validate,
  }),
  intl
)(FinanceIncome)
